import ErrorHandler from '@routes/UserGuard/ErrorHandler'
import { useUser } from '@state/user'

import GuardLoadingScreen from './GuardLoadingScreen'

import type { PropsWithChildren } from 'react'

function UserGuard({ children }: PropsWithChildren) {
  const { isError, error, isLoading } = useUser()

  if (isLoading) return <GuardLoadingScreen i18nKey="common.loadingStoreData" />

  if (isError) return <ErrorHandler message={error.message}/>

  return children
}

export default UserGuard